import React from 'react'

function Title({children}) {
  return (
    <h3 style={{ color: 'var(--secondary-color)',fontSize:'26px'}} className='my-2'>{children}</h3>

  )
}

export default Title